module.exports = __webpack_public_path__ + "media/promo/advent/images/logom-4-3756542ed60c0ca185c26f9f77b0dcab.png";